export const GET_OFFICE_EXPENSE_PENDING = "GET_OFFICE_EXPENSE_PENDING"
export const GET_OFFICE_EXPENSE_SUCCESS = "GET_OFFICE_EXPENSE_SUCCESS"
export const GET_OFFICE_EXPENSE_FAILURE = "GET_OFFICE_EXPENSE_FAILURE"

export const ADD_OFFICE_EXPENSE_PENDING = "ADD_OFFICE_EXPENSE_PENDING"
export const ADD_OFFICE_EXPENSE_SUCCESS = "ADD_OFFICE_EXPENSE_SUCCESS"
export const ADD_OFFICE_EXPENSE_FAILURE = "ADD_OFFICE_EXPENSE_FAILURE"

export const UPLOAD_OFFICE_EXPENSE_PENDING = "UPLOAD_OFFICE_EXPENSE_PENDING"
export const UPLOAD_OFFICE_EXPENSE_SUCCESS = "UPLOAD_OFFICE_EXPENSE_SUCCESS"
export const UPLOAD_OFFICE_EXPENSE_FAILURE = "UPLOAD_OFFICE_EXPENSE_FAILURE"

export const EDIT_OFFICE_EXPENSE_PENDING = "EDIT_OFFICE_EXPENSE_PENDING"
export const EDIT_OFFICE_EXPENSE_SUCCESS = "EDIT_OFFICE_EXPENSE_SUCCESS"
export const EDIT_OFFICE_EXPENSE_FAILURE = "EDIT_OFFICE_EXPENSE_FAILURE"

export const DELETE_OFFICE_EXPENSE_PENDING = "DELETE_OFFICE_EXPENSE_PENDING"
export const DELETE_OFFICE_EXPENSE_SUCCESS = "DELETE_OFFICE_EXPENSE_SUCCESS"
export const DELETE_OFFICE_EXPENSE_FAILURE = "DELETE_OFFICE_EXPENSE_FAILURE"

export const DOWNLOAD_OFFICE_EXPENSE_PENDING = "DOWNLOAD_OFFICE_EXPENSE_PENDING"
export const DOWNLOAD_OFFICE_EXPENSE_SUCCESS = "DOWNLOAD_OFFICE_EXPENSE_SUCCESS"
export const DOWNLOAD_OFFICE_EXPENSE_FAILURE = "DOWNLOAD_OFFICE_EXPENSE_FAILURE"
